import { useId } from 'react';
import { SvgBase } from 'components/ds';
import styles from './PhotoPicker.module.css';

/** 사진 고르기 — 파일 입력 하나를 라벨로 감쌉니다.
 *
 * 지금까지 화면마다 각자 <input type="file"> 을 두고 있어서(영수증·프로필·채팅)
 * 모양과 동작이 조금씩 달랐습니다. 장소 사진은 여러 자리에서 쓰이므로 한 벌만 둡니다.
 * 네이티브 앱에서도 파일 입력이 카메라/갤러리 선택을 띄우므로 브릿지 없이 동작합니다.
 */
export const PhotoPicker = ({
    label, onPick, multiple, disabled,
}: {
    label: string;
    onPick: (files: File[]) => void;
    multiple?: boolean;
    disabled?: boolean;
}) => {
    const id = useId();
    return (
        <>
            <input
                type="file"
                id={id}
                className={styles.input}
                accept="image/*"
                multiple={multiple}
                disabled={disabled}
                onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    if (files.length) onPick(files);
                    // 같은 파일을 다시 고를 수 있게 비웁니다
                    e.target.value = '';
                }}
            />
            <label htmlFor={id} className={disabled ? `${styles.slot} ${styles.slotOff}` : styles.slot}>
                <SvgBase size={20} strokeWidth={1.8}>
                    <path d="M12 5v14M5 12h14" />
                </SvgBase>
                <span className={styles.slotLabel}>{label}</span>
            </label>
        </>
    );
};
